(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AzioneDialogController', AzioneDialogController);

    AzioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Azione'];

    function AzioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Azione) {
        var vm = this;

        vm.azione = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.azione.id !== null) {
                Azione.update(vm.azione, onSaveSuccess, onSaveError);
            } else {
                Azione.save(vm.azione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:azioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
